import { EnvWindow } from '@curbside-health-inc/constants'
import { useHealthCheck } from '@curbside-health-inc/hooks'
import { ErrorPage, resolveCrashVariant, useToast } from '@curbside-health-inc/ui'
import { Dialog, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useEffect } from 'react'

import { BACK_ONLINE } from './constants'

declare let window: EnvWindow

interface ServerHealthProps {
  children: React.ReactNode
}

const ServerHealthMonitor: React.FC<ServerHealthProps> = ({ children }) => {
  const { isServerLive, retry, reconnected, siteError } = useHealthCheck()
  const { toast } = useToast()

  useEffect(() => {
    window.addEventListener('offline', retry)
    return () => window.removeEventListener('offline', retry)
  }, [retry])

  useEffect(() => {
    if (reconnected) toast({ intent: 'success', title: BACK_ONLINE })
  }, [reconnected, toast])

  if (!isServerLive) {
    return <ErrorPage variant={resolveCrashVariant()} onRetry={retry} />
  }

  if (siteError?.status) {
    return (
      <Dialog open aria-labelledby='site-error-title'>
        <DialogTitle id='site-error-title'>{siteError.error}</DialogTitle>
        <DialogContent>
          <DialogContentText>{siteError.message}</DialogContentText>
        </DialogContent>
      </Dialog>
    )
  }

  return <>{children}</>
}

const ServerHealth: React.FC<ServerHealthProps> = ({ children }) =>
  window._env_.HEALTH_CHECK_DISABLED === 'true' ? (
    <>{children}</>
  ) : (
    <ServerHealthMonitor>{children}</ServerHealthMonitor>
  )

export default ServerHealth
